export default {
  SET_LOADING(state, payload) {
    state.loading = payload;
  },
  SET_LOADING_TEMPLATES(state, payload) {
    state.loadingTemplates = payload;
  },
  SET_LOADING_ELEMENTS(state, payload) {
    state.loadingElements = payload;
  },
  SET_SELECTED_ELEMENT(state, payload) {
    state.selectedElement = payload;
  },
  SET_REPOSITORIES(state, payload) {
    state.repositories = payload;
  },
  SET_NESTED_FOLDERS(state, payload) {
    const newElements = payload.folders.map((folder) => ({
      parentFolder: payload.parentFolder,
      repositoryId: payload.repositoryId,
      fullpathId: payload.fullpathId,
      type: 'folder',
      ...folder
    }));
    state.foldersStack = newElements.reduce((accumulator, currentValue) => ({
      ...accumulator,
      [currentValue.carpetaId]: currentValue
    }), state.foldersStack);
  },
  UPDATE_FOLDER(state, payload) {
    const newFolders = { ...state.foldersStack };
    newFolders[payload.folderId].nombre = payload.name;
    state.foldersStack = newFolders;
  },
  UPDATE_FOLDERBLOCK(state, payload) {
    const newFolders = { ...state.foldersStack };
    newFolders[payload.folderId].blockEdit = payload.blockEdit;
    state.foldersStack = newFolders;
  },
  UPDATE_FOLDERTEMPLATE(state, payload) {
    const newFolders = { ...state.foldersStack };
    newFolders[payload.folderId].template = payload.template;
    state.foldersStack = newFolders;
  },
  SET_SELECTED_REPOSITORY(state, payload) {
    state.selectedRepositoryId = payload;
  },
  SET_SELECTED_FOLDER_ID(state, payload) {
    state.selectedFolderId = payload;
  },
  REMOVE_FOLDER(state, folderId) {
    const { [folderId]: ignored, ...copyFolders } = state.foldersStack;
    state.foldersStack = copyFolders;
  },
  REMOVE_FILE(state, fileId) {
    const { [fileId]: ignored, ...copyFilesStack } = state.filesStack;
    state.filesStack = copyFilesStack;
  },
  SET_FOLDERS_STACK(state, payload) {
    state.foldersStack = payload;
  },
  LOAD_FILES(state, payload) {
    state.filesStack = payload.reduce((accumulator, currentValue) => ({
      ...accumulator,
      [currentValue.archivoId]: currentValue
    }), state.filesStack);
  },
  SET_FILES_STACK(state, payload) {
    state.filesStack = payload;
  },
  SET_PERMISSIONS_STACK(state, payload) {
    state.permissionsStack = payload;
  },
  LOAD_PERMISSIONS_STACK(state, payload) {
    const permissionsStack = { ...state.permissionsStack };
    permissionsStack[payload.elementId] = payload.permissionsStack;
    state.permissionsStack = permissionsStack;
  },
  UPDATE_FILE(state, payload) {
    const newFilesStack = { ...state.filesStack };
    newFilesStack[payload.fileId].nombre = payload.name;
    newFilesStack[payload.fileId].esPublico = payload.isPublic;
    newFilesStack[payload.fileId].versionExterna = payload.externalVersion;
    newFilesStack[payload.fileId].estadoPublicacion = payload.publicationState;
    newFilesStack[payload.fileId].estadoAprobacion = payload.approvalState;
    newFilesStack[payload.fileId].estadoVigencia = payload.validityState;
    newFilesStack[payload.fileId].tipoExpiracion = payload.expirationType;
    newFilesStack[payload.fileId].fechaVencimiento = payload.expirationDate;
    state.filesStack = newFilesStack;
  },
  LOAD_SUBSCRIPTIONS_STACK(state, payload) {
    const subscriptionsStack = { ...state.subscriptionsStack };
    subscriptionsStack[payload.id] = payload.subscriptionsStack;
    state.subscriptionsStack = subscriptionsStack;
  },
  SET_APPROVALS(state, payload) {
    state.approvals = payload;
  },
  SET_PREVIOUS_VERSIONS(state, payload) {
    state.previousVersions = payload;
  }
};
